import { Component, Input } from '@angular/core';
import { BasicCardType, FlameListCardType } from '../../types/basic-card.type';
import { PictureBasicCardEnum } from '../../enums/basic-card.enum';
import { PictureBasicCardInterface } from '../../interfaces/basic-card.interface';

@Component({
    selector: 'app-basic-card',
    templateUrl: './basic-card.component.html',
    styleUrls: ['./basic-card.component.scss'],
    standalone: false
})
export class BasicCardComponent {
  get typeListCard(): FlameListCardType | undefined {
    if (this.type === 'none') {
      return undefined;
    }
    return this.type;
  }

  readonly typePicture = PictureBasicCardEnum;

  @Input() type: BasicCardType = 'none';

  @Input({ required: false }) picture!: PictureBasicCardInterface;

}
